import { useState } from 'react';
import Icon from './Icon';

// The document-status control on the supplier documents page (admin).
//
// It used to be a bare <select>, which cannot colour its options across
// browsers and read as a form field dropped into a table of badges. Now it is
// the same grammar as the payment-lifecycle control beside it: the current
// status rendered as its own badge (green תקין / red לא תקין) with a small
// chevron, opening a two-item panel where each choice carries its colour and
// glyph. One visual language for "a badge you can change".
//
// Only תקין / לא תקין: this page never lists drafts, so demoting a row to
// טיוטה would make it vanish — that move belongs to the document page.
const OPTIONS = [
  { value: 'תקין',    icon: 'check-circle', color: '#15803d', badge: 'badge-green' },
  { value: 'לא תקין', icon: 'alert',        color: '#b91c1c', badge: 'badge-red' },
];
const badgeClass = (value) => OPTIONS.find(o => o.value === value)?.badge || 'badge-gray';

export default function DocStatusControl({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block' }} onClick={e => e.stopPropagation()}>
      <button
        type="button"
        className="doc-status-control"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`סטטוס: ${value} — לחצי לשינוי`}
        title="שינוי סטטוס המסמך"
        disabled={disabled}
        onClick={() => setOpen(o => !o)}
      >
        <span className={`badge ${badgeClass(value)}`}>{value}</span>
        <span aria-hidden="true" style={{ color: 'var(--ink-muted)', display: 'inline-flex', lineHeight: 1 }}>
          <Icon name="chevron" size={14} />
        </span>
      </button>
      {open && (
        <>
          <div className="menu-backdrop" onClick={() => setOpen(false)} />
          <div className="page-menu-panel" role="menu" style={{ minWidth: 170 }}>
            {OPTIONS.map(o => (
              <button
                key={o.value}
                type="button"
                role="menuitemradio"
                aria-checked={o.value === value}
                className="page-menu-item"
                style={{ color: o.color, fontWeight: o.value === value ? 700 : 500 }}
                onClick={() => { setOpen(false); if (o.value !== value) onChange(o.value); }}
              >
                <Icon name={o.icon} size={16} />
                {o.value}
                {o.value === value && <span style={{ marginInlineStart: 'auto', fontSize: '0.72rem', color: '#94a3b8' }}>נוכחי</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </span>
  );
}
